export default __webpack_public_path__ + "static/media/corporate4.96bf4d65.png";